/* Match each content band within its visual row; never truncate product text. */
(() => {
  if (window.joviCollectionLayoutReady) return;
  window.joviCollectionLayoutReady = true;
  const fields = ['.mfc-col2__type', '.mfc-col2__title', '.mfc-col2__info>p', '.jovi-card-colors', '.mfc-col2__bottom'];
  const mounted = new WeakSet();
  function mount() {
    document.querySelectorAll('.mfc-col2__grid').forEach(grid => {
      if (mounted.has(grid)) return;
      mounted.add(grid);
      let frame = 0, width = -1;
      const align = () => {
        frame = 0;
        if (!grid.isConnected) return;
        const cards = [...grid.querySelectorAll('.mfc-col2__card')].filter(card => card.getClientRects().length);
        cards.forEach(card => fields.forEach(selector => card.querySelector(selector)?.style.removeProperty('min-height')));
        const rows = new Map();
        cards.forEach(card => {
          const top = Math.round(card.getBoundingClientRect().top);
          const key = [...rows.keys()].find(value => Math.abs(value - top) <= 2) ?? top;
          if (!rows.has(key)) rows.set(key, []);
          rows.get(key).push(card);
        });
        rows.forEach(row => fields.forEach(selector => {
          const cells = row.map(card => card.querySelector(selector)).filter(Boolean);
          const height = Math.ceil(Math.max(0, ...cells.map(cell => cell.getBoundingClientRect().height)));
          cells.forEach(cell => cell.style.setProperty('min-height', `${height}px`));
        }));
      };
      const schedule = () => { if (!frame) frame = requestAnimationFrame(align); };
      const resize = new ResizeObserver(entries => {
        const next = entries[0].contentRect.width;
        if (next !== width) { width = next; schedule(); }
      });
      resize.observe(grid);
      const mutations = new MutationObserver(schedule);
      mutations.observe(grid, { childList: true, subtree: true, characterData: true });
      grid.addEventListener('load', schedule, true);
      document.fonts?.ready.then(schedule);
      schedule();
      document.addEventListener('shopify:section:unload', event => {
        if (event.target.contains(grid)) { resize.disconnect(); mutations.disconnect(); cancelAnimationFrame(frame); }
      });
    });
  }
  mount();
  document.addEventListener('shopify:section:load', mount);
})();
